import { useState, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { DummyLoader, ListLoader } from "./list_loader.jsx";
import Loading from "./loading.jsx";
import Button from "./button.jsx";
import get from "../functions/get.js";
import post from "../functions/post.js";
import Lottie from "lottie-react";
import quizAnimation from "../quiz.json";
import Game from "./game.jsx";
import createCookie from "../functions/cookie.js";

const Quiz = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const [ mode, setMode ] = useState(null);

    const [ error, setError ] = useState("");

    const onFail = (res, data) => {
        setLoading(false);
        if(!res) {
            setError("Server nicht erreichbar!");
        }
    };

    useEffect(() => {

        setError("");
        setNoGame(false);

        if(location.pathname.includes("/erstellen") && !location.pathname.includes("id")) {
            setMode("choose");
        } else if(location.pathname.includes("/erstellen") && location.pathname.includes("id")) {
            setMode("create");

            const id = location.pathname.split("/");
            const currentID = id[id.length - 1];

            if(quizzes.length === 0) {
                getQuiz(currentID);
            } else {            
                const quiz = quizzes.filter(q => q.id === parseInt(currentID, 10));
                setCurrentQuiz(quiz[0]);
            }
        } else if (location.pathname.includes("/game")) {
            setMode("game");
            if (activeQuiz.code === "") {
                getGame();
            }
        } else {
            setMode("intro");
        }

    }, [location.pathname]);

    const [ largeScreen, setLargeScreen ] = useState(window.innerWidth >= 1100);

    useEffect(() => {

        const handleResize = () => {

            setLargeScreen(window.innerWidth >= 1100);

        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };

    }, []);

    const [ loading, setLoading ] = useState(false);
    const [ quizzes, setQuizzes ] = useState([]);
    const [ currentQuiz, setCurrentQuiz ] = useState(null);

    const onSuccess = (res, data) => {
        setLoading(false);

        if (!Array.isArray(data)) {
            setCurrentQuiz(data);
        } else {
            setQuizzes(data);
        }
    };

    const getQuiz = async (ID) => {

        const url = ID ? `/quiz/get?id=${ID}` : "/quiz/get";

        if(!loading) {
            setLoading(true);
        }

        get(url, onSuccess, onFail);

    };

    const [ showWarning, setShowWarning ] = useState("");
    const [ quizInfo, setQuizInfo ] = useState({
        players: "",
        timer: "",
    });

    const adjustInfo = (field, value) => {

        setQuizInfo(prev => {

            let newValue = value;

            if (field === "players") {
                const num = Number(value);
                if (num > 0 && (num < 2 || num > 5)) {
                    newValue = "";
                    setShowWarning("players");
                } else {
                    setShowWarning("");
                }
            }

            return {
                ...prev,
                [field]: newValue
            }
        });

    };

    const [ activeQuiz, setActiveQuiz ] = useState({
        code: "",
        quiz_id: "",
        title: "",
        timer: "",
        max_players: "",
        players: [],
        curren_question: 0,
    });

    const startQuiz = (res, data) => {
        setLoading(false);
        setActiveQuiz(data);
        navigate(`/quiz/game:code=${data.code}`);
    };

    const createGame = (event) => {

        event.preventDefault();
        setShowWarning("");

        const players = Number(quizInfo.players);

        if (players < 2 || players > 5) {
            setShowWarning("players");
            return;
        }

        const id = location.pathname.split("/");
        const currentID = id[id.length - 1];
        const hostCookie = createCookie();

        const bodyData = {
            ...quizInfo,
            quiz_id: currentID,
            user_cookie: hostCookie
        };

        setLoading(true);
        post("/quiz/create", bodyData, startQuiz, onFail);

    };

    const [ noGame, setNoGame ] = useState(false);

    const handleGetGame = (res, data) => {
        setLoading(false);
        setActiveQuiz(data);
    };

    const handleFail = (res, data) => {

        setLoading(false);
        setNoGame(true);

        if(!res) {
            setError("Server nicht erreichbar!");
        }

    };

    const getGame = () => {

        const code = location.pathname.split("=");
        const currentCode = code[code.length - 1];
        setLoading(true);
        get(`/quiz/game?code=${currentCode}`, handleGetGame, handleFail);

    };

    const [ enterCode, setEnterCode ] = useState(false);
    const [ code, setCode ] = useState("");

    const joinGame = () => {

        navigate(`/quiz/game:code=${code.toUpperCase()}`);

    };


    if(error) {
        return (
            <div className="start-warning">
                <p>{error}</p>
            </div>
        );
    }

  return (
    <div className="intro1" style={{padding: largeScreen ? "50px" : "80px 20px", maxWidth: "1400px"}}>

        {largeScreen &&
            <div className="quiz-image">
                <Lottie 
                    animationData={quizAnimation} 
                    loop={true}
                />
            </div>
        }

        {(mode === "intro" && !loading) &&
            <>
                <div style={{width: "100%", maxWidth: "500px"}}>
                    {!enterCode && 
                        <div className="quiz-intro">
                            <h1 className="title title-small">QUIZ</h1>

                            <p>Teste dein Wissen gegen andere Lernende in unserem Quizmodus.</p>

                        </div>
                    }

                    {enterCode &&
                        <div>

                            <label>Code: </label>

                            <input type="name" placeholder="1234..." maxLength={6} value={code} onChange={(e) => setCode(e.target.value)}/>

                        </div>
                    }

                     <div className="flex-col" style={{marginTop: "20px", width: "100%"}}>
                        <button className="button-yellow" style={{width: "100%"}} onClick={enterCode ? joinGame : () => setEnterCode(true)}>Beitreten</button>

                        <Link to={!enterCode ? "/quiz/erstellen" : ""} style={{width: "100%"}}>
                            <button 
                            className="button-blue" 
                            style={{width: "100%"}}
                            onClick={enterCode ? () => setEnterCode(false) : null}
                            >{enterCode ? "Zurück" : "Erstellen"}</button>
                        </Link>
                    </div>

                </div>
            </>
        }

        {(mode === "choose") &&
            <>
                <h1 className="title title-small">AUSWAHL</h1>

                <p style={{marginTop: "10px", marginBottom: "30px"}}>Wähle ein Quiz aus und starte das Spiel!</p>

                {!loading &&
                    <ListLoader url="/quiz/get" redirect = {`${location.pathname}/id`} />
                }

                {!loading &&
                    <div>
                        {quizzes.length > 0 &&
                            <ul style={{fontSize: "1.3rem"}}>
                                {quizzes.map((quiz, index) => {

                                    return (
                                        <li key={index}>
                                            <Link 
                                            className="flex-row" 
                                            style={{justifyContent: "flex-start"}} 
                                            to={`${location.pathname}:id=${quiz.id}`}
                                            >
                                                <div style={{height: "0.8rem", width: "0.8rem", background: "var(--blue)", borderRadius: "2px"}}></div>

                                                <p>{quiz.title}</p>
                                            </Link>
                                        </li>
                                    );
                                })}
                            </ul>
                        }
                    </div>
                }
            </>
        }

        {mode === "create" &&
            <>

                {loading &&
                    <Loading />
                }

                {!loading &&
                    <div style={{width: "100%", maxWidth: "500px"}}>
                        <h1 className="title title-small">{currentQuiz.title}</h1>

                        <p style={{marginTop: "10px", width: "70%", maxWidth: "500px"}}>{currentQuiz.description}</p>

                        <h2 style={{marginTop: "30px"}}>Einstellungen</h2>

                        <form>

                            <div className="form-elem">
                                <label>Anzahl Spielende: </label>

                                <input 
                                type="number" 
                                placeholder="max. 5" 
                                className="number-input" 
                                onChange={(e) => adjustInfo("players", e.target.value)}
                                value={quizInfo.players}/>

                                {showWarning.includes("players") &&
                                    <div className="form-warning">!</div>
                                }
                            </div>

                            <div className="form-elem">
                                <label>Timer: </label>

                                <select
                                className="number-input"
                                value={quizInfo.timer}
                                onChange={(e) => adjustInfo("timer", e.target.value)}
                                >
                                    <option value="">ohne</option>
                                    <option value={45}>kurz</option>
                                    <option value={90}>lang</option>
                                </select>

                            </div>

                            <div onClick={createGame}>
                                <Button className="button-yellow" text="Erstellen" style={{fontSize: "16px"}} />
                            </div>

                        </form>
                    </div>
                }

            </>
        }

        {mode === "game" && (
            loading ? (
                <Loading />
            ) :
            (
                <Game game={activeQuiz} potentialError={noGame ? "no game" : null}/>
            )
        )}

    </div>
  );
};

export default Quiz;